import React, { useCallback, useContext, useMemo, useRef, useState } from "react";
import { Box, Dialog, DialogContent, FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import ModAccName from 'components/ModAccName';
import { DialogFooter, DialogHeader } from 'components/dialog/DialogHeader';
import PaperComponent from "components/PaperComponent";
import { useEffect } from "react";
import ComboBox from "components/ComboBox";
import { expenseJobOrderApiNm, expenseJobOrderColNm } from "constants/expenseJobOrderConstant";
import { BoxFR } from "components/BoxCustom";
import { grey } from "@mui/material/colors";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { initExpenseJobOrderData } from "./initData";
import { alertError } from "components/Alert";
import { selectOnFocus } from "utils";



const ExpenseJobOrderDialogV2 = ({ dialogOpen, selectedExpJobOrdId, setDialogOpen, onFinish
  , expJobOrdData, selectedJobOrdId, updLnkSiteAbbr, excludeExpIds = [], usedExpIds = [] }) => {
  const { msData, ax } = useContext(GlobalStateContext);
  // const { msData } = useFinanceMsData();

  const [dialogData, setDialogData] = useState({ ...initExpenseJobOrderData })
  const untPrRef = useRef(null);
  const validation = useMemo(() => ({
    ExpNm: dialogData.ExpNm === ''
  }), [dialogData]);

  // Hide the reserved/excluded ExpIds (1-5) from the picker when adding an "other expense"
  const expCombo = useMemo(() => (
    excludeExpIds.length > 0
      ? msData.expCombo.filter(item => !excludeExpIds.includes(item.id))
      : msData.expCombo
  ), [msData.expCombo, excludeExpIds])

  const comboProp = useCallback((name, label, options) => ({
    // disabled: dialogData.ExpJobOrdId ? true : false,
    options: options,
    label: label,
    required: true,
    disabled: dialogData.ExpJobOrdId ? true : false,
    sx: { width: "100%" },
    selectedId: dialogData.ExpId,
    setSelectedId: async (id) => {

      if (usedExpIds.includes(id)) {
        alertError("ค่าใช้จ่ายนี้มีอยู่ในใบงานที่เลือกแล้ว ไม่สามารถเพิ่มซ้ำได้")
        return
      }
      console.log("expJobOrdData", expJobOrdData)
      const jobOrdIds = expJobOrdData?.JobOrdIds ? expJobOrdData.JobOrdIds : [selectedJobOrdId]
      const fnName = id === 1 ? "getTransportCharge" : "getUntPrFromJobOrdIds"
      if (jobOrdIds) {
        const postData = {
          JobOrdIds: jobOrdIds,
          ExpId: id
        }
        const value = await ax.post(`/expense-job/${fnName}`, postData, false)
        const exp = msData.expenses.find(item => item.ExpId === id)
        if (value.data && value.data.length > 0) {
          const data = value.data[0]
          setDialogData(oldState => {
            return {
              ...oldState,
              ExpId: id,
              ExpNm: exp?.ExpNm,
              UntPrB4Vat: Math.round(data.UntPr / (1 + +data.VatPrct / 100) * 100) / 100,
              UntPr: +data.UntPr,
              VatPrct: data.VatPrct,
              VatPr: data.VatPr,
              WhtPrct: data.WhtPrct,
              IsOwnRcpt: data.IsOwnRcpt,
              Total: +data.UntPr,
              ExpJobData: value.data
            }
          })
        } else {
          setDialogData(oldState => {
            if (exp) {
              return {
                ...oldState,
                ExpId: id,
                ExpNm: exp.ExpNm,
                UntPrB4Vat: Math.round(exp.UntPr / (1 + +exp.VatPrct / 100) * 100) / 100,
                UntPr: +exp.UntPr,
                VatPrct: exp.VatPrct,
                VatPr: exp.VatPr,
                WhtPrct: exp.WhtPrct,
                IsOwnRcpt: exp.IsOwnRcpt,
                Total: +exp.UntPr,
              }
            } else {
              return { ...oldState, ExpId: id }
            }
          })
        }
      }

    }
  }), [dialogData, msData, setDialogData, ax, expJobOrdData, selectedJobOrdId, usedExpIds])

  const dialogDataProp = useCallback((name) => ({
    disabled: dialogData.InvId ? true : false,
    variant: 'outlined',
    size: 'small',
    name: name,
    label: expenseJobOrderColNm[name],
    value: dialogData[name],
    error: validation[name],
    onChange: (e) => {
      setDialogData((oldState) => {
        let total = oldState.Total
        if (e.target.name === "Qty") {
          total = oldState.UntPr * e.target.value
        } else if (e.target.name === "UntPr") {
          total = oldState.Qty * e.target.value
        }
        return { ...oldState, [name]: e.target.value, Total: total }
      })
    }
  }), [dialogData, validation])

  const calculateVat = useCallback((isB4Vat) => (e) => {
    setDialogData(o => {
      const amnt = +e.target.value
      const newAmnt = isB4Vat ? amnt + amnt * +o.VatPrct / 100 : amnt / (1 + +o.VatPrct / 100)
      if (isB4Vat) {
        return { ...o, UntPr: Math.round(newAmnt * 100) / 100, Total: newAmnt * +o.Qty }
      } else {
        return { ...o, UntPrB4Vat: Math.round(newAmnt * 100) / 100, Total: amnt * +o.Qty }
      }
    })
  }, [])

  const handleDialogOk = useCallback(() => {
    if (!dialogData.IsCost && !dialogData.ExpId) {
      alertError("ใส่ข้อมูลไม่ครบถ้วน")
      return
    }
    onFinish(dialogData)
    setDialogOpen(false)
  }, [onFinish, dialogData, setDialogOpen])

  const handleDelete = useCallback(() => {
    onFinish({ ...dialogData, IsDel: 1 })
    setDialogOpen(false)
  }, [onFinish, setDialogOpen, dialogData])

  const handleUntPrKeyUp = useCallback((e) => {
    if (e.key === "Enter") {
      handleDialogOk()
    }
  }, [handleDialogOk])
  useEffect(() => {
    if (dialogOpen) {

      if (expJobOrdData) {
        setDialogData({
          ...expJobOrdData,
          UntPrB4Vat: (expJobOrdData.UntPr / (1 + +expJobOrdData.VatPrct / 100)).toFixed(2),
        })
      } else if (selectedExpJobOrdId) {
        const postData = {
          ExpJobOrdId: selectedExpJobOrdId,
          LnkSiteAbbr: updLnkSiteAbbr
        }
        ax.post(expenseJobOrderApiNm.getExpenseJobOrder, postData).then(value => {
          if (value.data && value.data.length > 0) {
            setDialogData({
              ...value.data[0],
              UntPrB4Vat: (+value.data[0].UntPr / (1 + +value.data[0].VatPrct / 100)).toFixed(2)
            })
          }
        })
      } else {
        setDialogData({ ...initExpenseJobOrderData })
      }

      //dont know why autoFocus not working if open dialog from cell click even use useRef
      // setTimeout can help to ensure that all ui rendered then set focus
      setTimeout(() => {
        if (untPrRef.current) {
          untPrRef.current.focus();
        }
      }, 10);
    } else {
      setDialogData({ ...initExpenseJobOrderData })
    }
  }, [dialogOpen, ax, expJobOrdData, selectedExpJobOrdId, updLnkSiteAbbr])



  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs' >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ค่าใช้จ่าย"
        onDeleteClick={dialogData.InvId ? null : handleDelete}
      />
      <DialogContent>
        <Box display='flex' flexDirection='column' gap={1} mt={2}>
          {/* <TextField {...dialogDataProp('IsCost')} select fullWidth label="รายได้-ต้นทุน" disabled={selectedExpJobOrdId} required>
            <MenuItem value={0}>รายได้</MenuItem>
            <MenuItem value={1}>ต้นทุน</MenuItem>
          </TextField> */}
          {dialogData.InvNo ? <Typography variant="h6" sx={{ mb: 1 }}>เลขที่ใบแจ้งหนี้: {dialogData.InvNo}</Typography> : null}
          {dialogData.JobOrdIds?.length > 1 ?
            <Typography variant="h6" sx={{ alignSelf: "center", mb: 1 }}>แก้ไขข้อมูลจำนวน {dialogData?.JobOrdIds?.length} แถว</Typography>
            : null
          }
          <ComboBox {...comboProp("ExpId", expenseJobOrderColNm.ExpNm, expCombo)} />
          <TextField {...dialogDataProp('UntPrB4Vat')} sx={{ backgroundColor: grey[200] }} type="number"
            label={<Typography>ราคา {<strong>ก่อน</strong>} Vat</Typography>}
            onBlur={calculateVat(true)} inputProps={{ style: { textAlign: "right" } }} onFocus={selectOnFocus} />

          <TextField inputRef={untPrRef} {...dialogDataProp('UntPr')} type="number" onFocus={selectOnFocus}
            label={<Typography>ราคา {<strong>หลัง</strong>} Vat</Typography>}
            onBlur={calculateVat(false)} inputProps={{ style: { textAlign: "right" } }}
            onKeyUp={handleUntPrKeyUp} />
          <TextField {...dialogDataProp('Qty')} inputProps={{ style: { textAlign: "right" } }} onFocus={selectOnFocus} />
          <TextField {...dialogDataProp('Total')} inputProps={{ style: { textAlign: "right" } }} disabled />
          <BoxFR>
            <TextField {...dialogDataProp('VatPrct')} sx={{ flexGrow: 1 }} inputProps={{ style: { textAlign: "right" } }}
              onFocus={selectOnFocus}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }} />
            <TextField {...dialogDataProp('WhtPrct')} sx={{ flexGrow: 1 }} inputProps={{ style: { textAlign: "right" } }}
              onFocus={selectOnFocus}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }} />
          </BoxFR>
          {
            !dialogData.IsCost &&

            <FormControl component="fieldset">
              <FormLabel component="legend">{expenseJobOrderColNm.IsOwnRcpt}</FormLabel>
              <RadioGroup row name='IsOwnRcpt' value={dialogData.IsOwnRcpt}
                onChange={(e) => { setDialogData((oldState) => ({ ...oldState, IsOwnRcpt: e.target.value })) }}>
                <FormControlLabel value={1} control={<Radio />} label="ใบเสร็จบริษัท" disabled={dialogData.InvId ? true : false} />
                <FormControlLabel value={0} control={<Radio />} label="ใบเสร็จลูกค้า" disabled={dialogData.InvId ? true : false} />
              </RadioGroup>
            </FormControl>
          }
          <TextField {...dialogDataProp('Rmk')} multiline rows={3} disabled={false} />
          {
            dialogData.selectedExpJobOrdId > 0 && <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} />
          }
        </Box>
      </DialogContent>
      <DialogFooter okText={selectedExpJobOrdId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(ExpenseJobOrderDialogV2)